import type { Goal } from "instantdb/types";

export const MENTAL_GOALS: Partial<Goal>[] = [
  {
    id: "daily-mindfulness-practice",
    title: "Daily mindfulness practice",
    description: "Set aside time each day for mindfulness meditation",
    symbol: "🧠",
  },
  {
    id: "cognitive-challenges",
    title: "Cognitive challenges",
    description: "Engage in activities that challenge your brain",
    symbol: "🧩",
  },
  {
    id: "digital-wellness",
    title: "Digital wellness",
    description: "Create healthy boundaries with technology",
    symbol: "📱",
  },
];
